export default {
  getOrgTarget: (state) => state.orgTarget,
};
